import { render, staticRenderFns } from "./merchants-list.vue?vue&type=template&id=32525c44&scoped=true&lang=pug&"
import script from "./merchants-list.vue?vue&type=script&lang=js&"
export * from "./merchants-list.vue?vue&type=script&lang=js&"
import style0 from "./merchants-list.vue?vue&type=style&index=0&id=32525c44&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32525c44",
  null
  
)

export default component.exports